// // function ResumePreview({ onDownload }) {
// //   return (
// //     <div className="rb-loader-backdrop">
// //       <div className="rb-preview-card">
// //         <h3>Quick Resume Snapshot</h3>

// //         <div className="rb-preview-score">
// //           <strong>62%</strong> ATS Ready
// //         </div>

// //         <ul>
// //           <li>✔ ATS Parsing: PASS</li>
// //           <li>⚠ Missing keywords</li>
// //           <li>⚠ Low recruiter impact</li>
// //         </ul>

// //         <button className="rb-preview-btn" onClick={onDownload}>
// //           Download Full Report
// //         </button>

// //         <p className="rb-preview-note">
// //           Full report & fixed resume available after login.
// //         </p>
// //       </div>
// //     </div>
// //   );
// // }
// function ResumePreview({ score, role, onDownload }) {
//   return (
//     <div className="rb-loader-backdrop">
//       <div className="rb-preview-card large">

//         {/* SCORE */}
//         <div className="rb-score-wrap">
//           <div className="rb-score-circle">
//             <svg width="120" height="120">
//               <circle cx="60" cy="60" r="52" />
//               <circle
//                 cx="60"
//                 cy="60"
//                 r="52"
//                 style={{
//                   strokeDasharray: 326,
//                   strokeDashoffset: 326 - (326 * score) / 100,
//                 }}
//               />
//             </svg>
//             <div className="rb-score-text">
//               <span>{score}</span>
//               <small>/100</small>
//             </div>
//           </div>

//           <div>
//             <h3>ATS Score: {score}%</h3>
//             <p>
//               Your resume for <strong>{role}</strong> roles needs improvement.
//             </p>
//           </div>
//         </div>

//         {/* BEFORE / AFTER */}
//         <div className="rb-compare">
//           <div>
//             <h4>❌ Before</h4>
//             <p>Worked on data pipelines</p>
//           </div>

//           <div>
//             <h4>✅ After</h4>
//             <p>
//               Built scalable data pipelines using Airflow & Python, processing
//               10M+ records daily and reducing failures by 35%
//             </p>
//           </div>
//         </div>

//         {/* CTA */}
//         <button className="rb-preview-btn" onClick={onDownload}>
//           Download Full ATS Report
//         </button>

//         <p className="rb-preview-note">
//           Includes keyword gaps, fixes & recruiter-ready bullets (PDF)
//         </p>
//       </div>
//     </div>
//   );
// }

// function ResumePreview({ score, role, onDownload }) {
//   return (
//     <div className="rb-loader-backdrop">
//       <div className="rb-preview-card large">

//         {/* SCORE */}
//         <div className="rb-score-wrap">
//           <div className="rb-score-circle">
//             <svg width="120" height="120">
//               <circle cx="60" cy="60" r="52" />
//               <circle
//                 cx="60"
//                 cy="60"
//                 r="52"
//                 style={{
//                   strokeDasharray: 326,
//                   strokeDashoffset: 326 - (326 * score) / 100,
//                 }}
//               />
//             </svg>
//             <div className="rb-score-text">
//               <span>{score}</span>
//               <small>/100</small>
//             </div>
//           </div>

//           <div>
//             <h3>ATS Score: {score}%</h3>
//             <p>
//               Your resume for <strong>{role}</strong> roles needs improvement.
//             </p>
//           </div>
//         </div>

//         {/* SUMMARY CHECKS */}
//         <ul className="rb-preview-points">
//           <li>✔ ATS parsing: PASS</li>
//           <li>⚠ Keyword gaps detected</li>
//           <li>⚠ Recruiter impact can be improved</li>
//         </ul>

//         {/* CTA */}
//         <button className="rb-preview-btn" onClick={onDownload}>
//           Unlock Full ATS Report
//         </button>

//         <p className="rb-preview-note">
//           Includes keyword gaps, AI fixes & recruiter-ready bullets (PDF)
//         </p>
//       </div>
//     </div>
//   );
// }


// function ResumePreview({
//   score,
//   role,
//   atsParsing,
//   jobMatch,
//   recruiterImpact,
//   previewImprovements = [],
//   onDownload
// }) {

//   const circumference = 326
//   const dashoffset = circumference - (circumference * score) / 100

//   return (
//     <div className="rb-loader-backdrop">
//       <div className="rb-preview-card large">

//         {/* SCORE */}
//         <div className="rb-score-wrap">
//           <div className="rb-score-circle">

//             <svg width="120" height="120">
//               <circle cx="60" cy="60" r="52" className="rb-score-bg" />
//               <circle
//                 cx="60"
//                 cy="60"
//                 r="52"
//                 className="rb-score-progress"
//                 style={{
//                   strokeDasharray: circumference,
//                   strokeDashoffset: dashoffset
//                 }}
//               />
//             </svg>

//             <div className="rb-score-text">
//               <span>{score}</span>
//               <small>/100</small>
//             </div>

//           </div>

//           <div>
//             <h3>ATS Score: {score}%</h3>
//             <p>
//               Resume match for <strong>{role}</strong> roles.
//             </p>
//           </div>
//         </div>


//         {/* RESULT SUMMARY */}
//         <ul className="rb-preview-points">

//           <li>
//             {atsParsing === "PASS" ? "✔" : "❌"} ATS Parsing: {atsParsing}
//           </li>

//           <li>
//             {jobMatch === "HIGH"
//               ? "✔ Strong keyword match"
//               : jobMatch === "MEDIUM"
//               ? "⚠ Moderate keyword match"
//               : "❌ Low keyword match"}
//           </li>

//           <li>
//             {recruiterImpact === "HIGH"
//               ? "✔ Strong recruiter impact"
//               : recruiterImpact === "MEDIUM"
//               ? "⚠ Recruiter impact can improve"
//               : "❌ Low recruiter impact"}
//           </li>

//         </ul>


//         {/* AI IMPROVEMENT PREVIEW */}
//         {previewImprovements.length > 0 && (
//           <div className="rb-preview-improvements">
//             <h4>AI Suggestions</h4>
//             <ul>
//               {previewImprovements.map((imp, i) => (
//                 <li key={i}>• {imp}</li>
//               ))}
//             </ul>
//           </div>
//         )}


//         {/* CTA */}
//         <button className="rb-preview-btn" onClick={onDownload}>
//           Unlock Full ATS Report
//         </button>

//         <p className="rb-preview-note">
//           Includes keyword gaps, AI fixes & recruiter-ready resume (PDF)
//         </p>

//       </div>
//     </div>
//   )
// }

// export default ResumePreview

function ResumePreview({
  score,
  role,
  atsParsing,
  jobMatch,
  recruiterImpact,
  previewImprovements = [],
  onDownload
}) {

  // ✅ SAFETY FIX (CRITICAL)
  const safeScore = Number(score) || 0;

  const circumference = 326;
  const dashoffset =
    circumference - (circumference * safeScore) / 100;

  return (
    <div className="rb-loader-backdrop">
      <div className="rb-preview-card large">

        {/* SCORE */}
        <div className="rb-score-wrap">
          <div className="rb-score-circle">

            <svg width="120" height="120">
              <circle cx="60" cy="60" r="52" className="rb-score-bg" />
              <circle
                cx="60"
                cy="60"
                r="52"
                className="rb-score-progress"
                style={{
                  strokeDasharray: circumference,
                  strokeDashoffset: dashoffset
                }}
              />
            </svg>

            <div className="rb-score-text">
              <span>{safeScore}</span>
              <small>/100</small>
            </div>

          </div>

          <div>
            <h3>ATS Score: {safeScore}%</h3>
            <p>
              Resume match for <strong>{role || "your target role"}</strong> roles.
            </p>
          </div>
        </div>

        {/* STATUS */}
        <ul className="rb-preview-points">

          <li>
            {atsParsing === "PASS" ? "✔" : "❌"} ATS Parsing: {atsParsing || "FAIL"}
          </li>

          <li>
            {jobMatch === "HIGH"
              ? "✔ Strong keyword match"
              : jobMatch === "MEDIUM"
              ? "⚠ Moderate keyword match"
              : "❌ Low keyword match"}
          </li>

          <li>
            {recruiterImpact === "HIGH"
              ? "✔ Strong recruiter impact"
              : recruiterImpact === "MEDIUM"
              ? "⚠ Recruiter impact can improve"
              : "❌ Low recruiter impact"}
          </li>

        </ul>

        {/* AI SUGGESTIONS */}
        {previewImprovements.length > 0 && (
          <div className="rb-preview-improvements">
            <h4>AI Suggestions</h4>
            <ul>
              {previewImprovements.map((imp, i) => (
                <li key={i}>• {imp}</li>
              ))}
            </ul>
          </div>
        )}

        {/* CTA */}
        <button className="rb-preview-bt" onClick={onDownload}>
          Unlock Full ATS Report
        </button>

        <p className="rb-preview-note">
          Includes keyword gaps, AI fixes & recruiter-ready resume (PDF)
        </p>

      </div>
    </div>
  );
}

export default ResumePreview;